export const alertSelector = state => state.ui.alert;
export const notificationSelector = state => state.ui.notification;
export const isSystemInitialisedSelector = state => state.ui.isSystemInitialised;
